export const GET_BANKS_LEVEL_LIST = "GET_BANKS_LEVEL_LIST";
export const GET_MEMBER_GROUP_NAME = "GET_MEMBER_GROUP_NAME";
export const GET_BANKS_ACCOUNT_NAME = "GET_BANKS_ACCOUNT_NAME";
export const CREATE_BANKS_LEVEL = "CREATE_BANKS_LEVEL";
export const UPDATE_STATUS_BANKS_LEVEL = "UPDATE_STATUS_BANKS_LEVEL";
export const SHOW_BANKS_LEVEL = "SHOW_BANKS_LEVEL";
export const UPDATE_BANKS_LEVEL = "UPDATE_BANKS_LEVEL";
export const DELETE_BANKS_LEVEL = "DELETE_BANKS_LEVEL";